/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { BsFillPeopleFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getUsersCount } from '../../../../../../store/reducers/user/userAction';


const AdminUsersCount = () => {
    const dispatch = useDispatch();
    const usersCount = useSelector(state => state.user.usersCount)
    useEffect(() => {
        dispatch(getUsersCount())
    }, [dispatch]);

    return (
        <>
            <Tooltip title="Admin users Count" placement="left" arrow>
                <div   style={{float:'right',marginRight:'20px'}}>
                    <IconButton color="primary" style={{backgroundColor:'#36d7914a' }}>
                        <Badge badgeContent={usersCount?.count} color="success">
                            <BsFillPeopleFill />
                        </Badge>
                    </IconButton>
                </div>
            </Tooltip>
        </>
    )

}
 
export default AdminUsersCount;
